import { COLORS } from 'helpers/globals'

export default {
  wrapper: {
    margin: '0 .75rem 1rem .75rem',
    borderRadius: '1rem',
    background: COLORS.tertiary,
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1.4rem',
    color: 'black',
    alignSelf: 'start'
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    padding: '.8rem',
    border: `1px solid ${COLORS.primary}`,
    overflow: 'hidden',
    '&:not(:last-of-type)': { borderBottom: 'none' },
    '&:first-of-type': {
      borderTopLeftRadius: '1rem',
      borderTopRightRadius: '1rem'
    },
    '&:last-of-type': {
      borderBottomLeftRadius: '1rem',
      borderBottomRightRadius: '1rem'
    }
  },
  label: {
    flex: 1,
    fontSize: '1.6rem'
  },
  header: {
    flex: 1,
    fontSize: '1.6rem',
    fontWeight: 400
  },
  fadeAppear: {
    opacity: 0,
    height: 0
  },
  fadeAppearActive: {
    opacity: 1,
    transition: 'opacity 200ms, height 200ms'
  },
  fadeAppearDone: {
    height: 'auto'
  },
  fadeEnter: {
    opacity: 0,
    height: 0,
    transition: 'opacity 200ms, height 200ms'
  },
  fadeEnterActive: {
    opacity: 1,
    transition: 'opacity 200ms, height 200ms'
  },
  fadeEnterDone: {
    height: 'auto'
  },
  fadeExit: {
    opacity: 1
  },
  fadeExitActive: {
    opacity: 0,
    height: 0,
    transition: 'opacity 200ms, height 200ms'
  },
  fadeExitDone: {
    height: 0,
    opacity: 0
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorControllerDesigner/DoorConfiguration/PeripheralLimitGroup/style.js